import OwnerList from "containers/owner/OwnerList";
import React, { Component } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import 'react-table/react-table.css';
import { PacmanLoader } from 'react-spinners';
import Select from 'react-select';
import axios from 'axios';
import { API } from "aws-amplify";

const CancelToken = axios.CancelToken;
const source = CancelToken.source();



export default class OwnerSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            property_key: '',
            name: '',
            acn: '',
            iscompany: null,
            iscompanyOptions : [{label: "Companies & Individuals",value: null},{label: "Owner is a company",value: true},{label: "Owner is an individual",value: false}],
            selectedIsCompanyOption:  {label: "Companies & Individuals",value: null},
            isLoading: true,
            owners: [],
            filter: {},
            controlType: "table",
            selectedCityscope: null,
            cityscopeOptions: [],
            cityscope: null
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        
        
    }
    
  
    async componentDidMount() {
        
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if (this.props.controlType){
            this.setState({controlType: this.props.controlType})
        }
        else
        {
            document.title = "Cityscope Owner Search";
        }

        await this.getCityscopes();

        this.setState({ isLoading: false });      
    }

    async getCityscopes() {
        try {
            API.get("colin", `/cityscopes/dropdown`, { 'cancelToken': source.token }).then((cityscopeOptions) => {
                if (cityscopeOptions) {
                    this.setState(state => ({ cityscopeOptions }));
                }
            });
        }
        catch{
            console.log("Error getting cityscopes");
        }
    }    

    handleCityscopeChange = async (selectedCityscope) => {
        this.setState({ 
            selectedCityscope,
            cityscope: (selectedCityscope) ? selectedCityscope.map(r => r.value).join(",") : null,
        });
    }

    handleChange = event => {
        
        this.setState({
            [event.target.id]: event.target.value
        });
        
    }

    handleCheckBoxChange = event => {

        let name = event.target.name
        this.setState({
            [name]: event.target.checked
        })

        

    }

    handleSIsCompanyChange = (selectedIsCompanyOption) => {
        this.setState({ modified: true });
        if (selectedIsCompanyOption) {
            this.setState({ selectedIsCompanyOption, iscompany: selectedIsCompanyOption.value });          
        }
        else {
            this.setState({ selectedIsCompanyOption: { value: null, label: null } });
            this.setState({ iscompany: null });
            
        }
    }

   
    handleSubmit(event) {
        
        event.preventDefault();
        this.setState({ isLoading: true });
        console.log(this.state.filter);
 

        this.setState(state => ({
                        filter : {
                            scope: this.state.cityscope,
                            propertyid: this.state.property_key,
                            name: this.state.name,
                            acn: this.state.acn,
                            iscompany: this.state.iscompany
                        }          
        }));

    
     }

    renderOwners() {
        return (
            
                <Container fluid >
                    <Row >
                        <Col sm={12} md={12} lg={12}>
                            <h6>
                                Cityscope Owner Search
                                </h6>
                    
                        </Col>
                    </Row>
                    
                        

                <Form onSubmit={this.handleSubmit}>
                    <Form.Row >

                        <Col lg={2}>
                            <Form.Group controlId="cityscope">
                                <Select
                                    value={this.state.selectedCityscope}
                                    onChange={this.handleCityscopeChange}
                                    options={this.state.cityscopeOptions}
                                    onInputChange={this.handleInputChange}
                                    placeholder="Cityscope (leave blank for all)"
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                        
                        <Col lg={2}>
                            <Form.Group controlId="property_key">
                                <Form.Control
                                    value={this.state.property_key}
                                    onChange={this.handleChange}
                                    componentClass="input"
                                    type="text"
                                    placeholder="Cityscope Reference starting"
                                />
                            </Form.Group>
                            </Col>
                        
                        <Col lg={2}>
                        <Form.Group controlId="name">
                                <Form.Control
                                    type="input"
                                    value={this.state.name}
                                    onChange={this.handleChange}
                                    placeholder="Owner Name or Key containing" />
                            
                            </Form.Group>
                        </Col>
                        <Col lg={2}>
                        <Form.Group controlId="acn">
                            
                                <Form.Control
                                    type="input"
                                    value={this.state.acn}
                                    onChange={this.handleChange}
                                    placeholder="ACN containing"
                                />
                            
                        </Form.Group>
                        </Col>
                        <Col lg={2}>
                        <Form.Group controlId="iscompany">
                            <Select
                                    value={this.state.selectedIsCompanyOption}
                                    onChange={this.handleSIsCompanyChange}
                                    options={this.state.iscompanyOptions}
                                        
                                    placeholder="Scope" 
                                    isClearable={true}                            
                                />
                            </Form.Group>

                     
                        </Col>
                        <Col sm={2} md={1} lg={1}>
                            <Button type="submit">Search</Button>
                        </Col>
                        
                    </Form.Row>
                </Form>
                        

                    <Row className="show-Container">
                    <Col sm={12} md={12} lg={12}>

                            <OwnerList
                            filter={this.state.filter}
                            isAuthenticated={this.props.isAuthenticated}
                            isLoading={this.state.isLoading}
                            properties={this.props.properties}
                            controlType={this.state.controlType}
                            ownerid={this.props.ownerid}
                            saleid={this.props.saleid}
                            buyerSellers={this.props.buyerSellers}
                            updateTableState ={this.props.updateTableState}
                            saveRecord={this.props.saveRecord}
                            refreshDataSet={this.props.refreshDataSet}
                            />

                        </Col>
                    </Row>
                </Container>

        );
    }
  render() {
    return (

        <div className="OwnerSearch">
            {this.props.isAuthenticated ? this.renderOwners() : console.log("error)")}
        </div>
    );
  }
}
